import Field from "@hudson/ui/components/FormFields/Field";
import Input from "@hudson/ui/components/FormFields/Input";

function Name({
  autoFocus,
  className = "",
  errorMessage,
  fieldName,
  label,
  onBlur,
  requiredPlaceholder,
}: {
  autoFocus?: boolean;
  className?: string;
  errorMessage?: string;
  fieldName: string;
  label: string;
  onBlur?: () => void;
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Input
          autoComplete="name"
          autoFocus={autoFocus}
          className="w-72"
          inError={inError}
          onBlur={onBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          requiredPlaceholder={requiredPlaceholder}
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{ required: errorMessage }}
      label={label}
      onBlur={onBlur}
    />
  );
}

export default Name;
